module.exports = __webpack_public_path__ + "static/media/logo_aiPlato-black-h.62120a6b.png";